module.exports = __webpack_public_path__ + "img/35.4932f571.jpg";